import {ReactElement, useState} from "react";
import {Body, Footer, FooterItem, Header, Modal} from "@zendeskgarden/react-modals";
import {Button} from "@zendeskgarden/react-buttons";
import UserFormInput from "../../users/components/user-form/UserFormInput";
import * as formCss from "../../users/components/user-form/styles/userFormStyles.module.scss";
import {
    useCreatePayrollPositionMutation,
    useUpdatePayrollPositionMutation
} from "../../../../__generated__/generated_types";
import {toast} from "react-toastify";

interface PositionFormModalProps {
    closed: (saved: boolean) => void;
    existingPosition?: {
        id: string;
        name: string;
        employeeCount: number;
    };
}

export function PositionFormModal(props: PositionFormModalProps): ReactElement {
    const [createPosition, {loading: createLoading}] = useCreatePayrollPositionMutation({});
    const [updatePosition, {loading: updateLoading}] = useUpdatePayrollPositionMutation({});
    const [name, setName] = useState<string>(props.existingPosition?.name ?? "");
    const [nameTouched, setNameTouched] = useState<boolean>(false);

    function doSave(): void {
        let promise: Promise<unknown>;
        if(props.existingPosition) {
            promise = updatePosition({
                variables: {
                    id: props.existingPosition.id,
                    name: name
                }
            });
        } else {
            promise = createPosition({
                variables: {
                    name: name
                }
            });
        }

        promise.then(() => {
            toast.success("Position Saved!");
            props.closed(true);
        }).catch(() => {/* Do Nothing */});
    }

    return <Modal>
        <Header>
            {props.existingPosition ? "Edit Position" : "Create Position"}
        </Header>
        <Body>
            <form className={formCss.userForm}>
                <UserFormInput
                    label="Name"
                    placeholder="Position Name"
                    required
                    value={name}
                    error={nameTouched && name === "" ? "Name cannot be empty." : undefined}
                    onChange={(evt) => {
                        setName(evt.target.value);
                        setNameTouched(true);
                    }}
                    onBlur={() => {/* Do Nothing */}}
                />
            </form>
        </Body>
        <Footer>
            <FooterItem>
                <Button onClick={() => props.closed(false)}>Cancel</Button>
            </FooterItem>
            <FooterItem>
                <Button
                    isPrimary
                    disabled={createLoading || updateLoading || !(name && name !== "")}
                    onClick={() => doSave()}
                >Save</Button>
            </FooterItem>
        </Footer>
    </Modal>;
}
